import featureFlags from '../lib/featureFlags';

const useFeature = (flagName) => featureFlags[flagName] ?? false;

export default useFeature;
